import { censusGraphsPlaceImpact } from '../census-graphs';
import { submarketCounts } from '../multi-parcel-report';

export const multiparcelReport = {
  id: 'MULTI_PARCEL_REPORT',
  identifier: 'fips',
  sections: [
    {
      title: 'Multi-Parcel Report',
      titleSelector: 'layer.label',
      properties: [
        {
          column: 'geom',
          padding: 1,
          type: 'MAP',
          options: ['HIDE_STREETVIEW', 'SINGLE_PARCEL'],
        },
        {
          type: 'ACTIONS',
          options: ['PRINT', 'CSV', 'SHAPEFILE'],
          props: [
            'name',
            'demo_impact_pred',
            'ed_assoc_plus',
            'ed_ba_plus',
            'ed_ba_plus',
            'ed_doc_plus',
            'ed_hs_plus',
            'emp_pct',
            'enroll_preschool',
            'enroll_preschool_pct',
            'hh_w_kids',
            'hispanic',
            'homes_impacted',
            'housing_affordability',
            'housing_affordability_owners',
            'housing_affordability_renters',
            'hu_own_occ',
            'hu_unocc',
            'ind_agff',
            'ind_art',
            'ind_construction',
            'ind_ed',
            'ind_finance',
            'ind_info',
            'ind_manufacture',
            'ind_other',
            'ind_pro_science',
            'ind_public',
            'ind_retail',
            'ind_trans',
            'ind_wholesale',
            'med_hh_inc',
            'med_hom_val',
            'med_rent',
            'population',
            'pov_pct',
            'rc_2p',
            'rc_afam',
            'rc_asian',
            'rc_islnd',
            'rc_natv',
            'rc_other',
            'rc_white',
            'rehab_impact_pred',
            'social_vulnerability',
            'submarket',
            'unemp_pct',
          ],
        },
        {
          column: 'fips+bg',
          label: 'Number of Block Groups Selected',
          type: 'NUMBER',
          method: 'countblockgroups',
        },
        {
          column: 'fips+county',
          label: 'Number of Counties Selected',
          type: 'NUMBER',
          method: 'countcounties',
        },
        {
          column: 'fips+city',
          label: 'Number of Municipalities Selected',
          filterString: 'is_latest=1&sumlevel=60&sumlevel=150&sumlevel=160',
          type: 'NUMBER',
          method: 'countcities',
        },
        ...censusGraphsPlaceImpact({ prepend: 'Avg.' }),
        ...submarketCounts(),
      ],
    },
  ],
};
